import ReactDOM from "react-dom/client";
import App from "./App.tsx";

// Temporary test utility - remove after confirming Redux modals work
import "./debug-modal-test.ts";

ReactDOM.createRoot(document.getElementById("root")!).render(<App />);
